export const CALCULATOR_TAGS = {
  CALCULATOR_COLLAGEN_LIST: 'calculatorCollagenList',
  CALCULATOR_COLLAGEN_PUSH_EMAIL: 'calculatorCollagenPushEmail',
}
